







































import { Component, Mixins } from 'vue-property-decorator'
import GlobalMixin, {ALERT_TYPE} from '@/mixins/globalMixin'
import LoadingComponent from '@/components/LoadingComponent.vue'
import AlertBarComponent from '@/components/AlertBarComponent.vue'
import BreadcrumbsComponent from '@/components/BreadcrumbsComponent.vue'
import SelectMonthComponent from '@/components/SelectMonthComponent.vue'
import { Statistics } from '@/domain/Statistics'
import StatisticsService, { SerchConditon } from '@/service/StatisticsService'
import DateUtils from '@/utils/DateUtils'

@Component({
  components: {
    LoadingComponent,
    AlertBarComponent,
    BreadcrumbsComponent,
    SelectMonthComponent,
  },
})
export default class MemberExport extends Mixins(GlobalMixin) {
  statisticsService = StatisticsService.instance

  /** 抽出条件 */
  conditions = new SerchConditon()
  /** 対象データ 1:受注データ, 2:売上見込データ, 3:売上データ */
  target = 1

  /**
   * 初期実行
   */
  mounted() {
    /* 初期抽出条件 */
    const conditions = sessionStorage.getItem("tool.export.conditions")
    if (conditions !== null) {
      this.conditions = JSON.parse(conditions) as SerchConditon
    }
  }

  /**
   * エクスポート処理
   */
  onExport() {
    this.showLoading()
    sessionStorage.setItem("tool.export.conditions", JSON.stringify(this.conditions))
    switch (this.target) {
      case 1:
        /* 受注データ */
        this.onOrdersExport()
        break;
      case 2:
        /* 売上見込データ */
        this.onExpectedSalesExport()
        break;
      case 3:
        /* 売上データ */
        this.onSalesExport()
        break;
      default:
        this.alert("対象データエラー", ALERT_TYPE.ERROR)
        this.hideLoading()
        break;
    }
  }

  /**
   * 受注データエクスポート
   */
  onOrdersExport() {
    this.statisticsService.findOrders(this.conditions)
      .then(x => {
        /* CSVファイルに変換およびダウンロード */
        this.csvDownload("受注データ", x)
        this.hideLoading()
      })
      .catch(error => {
        // eslint-disable-next-line
        console.log(error)
        this.alert("エクスポートエラー", ALERT_TYPE.ERROR)
        this.hideLoading()
      })
  }

  /**
   * 売上見込データエクスポート
   */
  onExpectedSalesExport() {
    this.statisticsService.findExpectedSales(this.conditions)
      .then(x => {
        /* CSVファイルに変換およびダウンロード */
        this.csvDownload("売上見込データ", x)
        this.hideLoading()
      })
      .catch(error => {
        // eslint-disable-next-line
        console.log(error)
        this.alert("エクスポートエラー", ALERT_TYPE.ERROR)
        this.hideLoading()
      })
  }

  /**
   * 売上データエクスポート
   */
  onSalesExport() {
    this.statisticsService.findSales(this.conditions)
      .then(x => {
        /* CSVファイルに変換およびダウンロード */
        this.csvDownload("売上データ", x)
        this.hideLoading()
      })
      .catch(error => {
        // eslint-disable-next-line
        console.log(error)
        this.alert("エクスポートエラー", ALERT_TYPE.ERROR)
        this.hideLoading()
      })
  }

  /**
   * 共通CSVファイルに変換およびダウンロード
   */
  private csvDownload(dataName: string, result: Statistics[]) {
    /* CSVファイルに変換およびダウンロード */
    const dateUtils = DateUtils.instance
    const fileName = `${dataName}_${dateUtils.format(this.conditions.startOn, "yyyyMMdd")}-${dateUtils.format(this.conditions.endOn, "yyyyMMdd")}.csv`
    const header = Statistics.getHeader().map(x => `"${x}"`).join(",")
    const response = result.map(x => x.toCsv())
              .reduce((p, x) => p + "\r\n" + x, header)
    const responseFile = this.convertFile(fileName, "text/csv", response)
    this.download(responseFile)
  }
}
